/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import styles from '../../../styles/components/pageComponents/program/AddSolution.module.css';

interface AddSolutionProps {
	onOk: (solutionName: string) => void;
	onCancel: () => void;
}

export default function AddSolution({ onOk, onCancel }: AddSolutionProps) {
	const [solutionName, setSolutionName] = useState('');

	const handleOkClick = () => {
		// Prevent submission if it's just empty spaces
		if (solutionName.trim()) {
			onOk(solutionName.trim());
			setSolutionName(''); // Optional: clear input after submitting
		}
	};

	// Determine if the OK button should be disabled (empty or just whitespace)
	const isOkDisabled = solutionName.trim().length === 0;

	return (
		<div className={styles.card}>
			<h2 className={styles.title}>Add New Offering</h2>

			<div className={styles.inputGroup}>
				<label htmlFor="solution-name" className={styles.label}>
					Offering Name <span className={styles.asterisk}>*</span>
				</label>
				<input
					id="solution-name"
					type="text"
					className={styles.input}
					placeholder="Enter Offering name..."
					value={solutionName}
					onChange={e => setSolutionName(e.target.value)}
					autoFocus
				/>
			</div>

			<div className={styles.actions}>
				<button
					type="button"
					className={styles.cancelBtn}
					onClick={onCancel}
				>
					Cancel
				</button>
				<button
					type="button"
					className={styles.okBtn}
					onClick={handleOkClick}
					disabled={isOkDisabled}
				>
					OK
				</button>
			</div>
		</div>
	);
}
